import styled from 'styled-components';
import { FooterBlockWrapper } from '@app/ui/pages/landing-page/footer/footer.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FooterInfoWrapper = styled(FooterBlockWrapper as any)`
  max-width: 400px;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FooterInfoLogoWrapper = styled.div<any>`
  padding-bottom: 15px;
`;
